import {
  getSiteConfig,
  getTranslations,
  getTopicPage,
  getTopicPageSlugs,
  getHelpPost,
  getHelpPostSlugs,
  getPage,
  getPageSlugs,
} from '@sh24/contentful-service'
import { previewClient, contentDeliveryClient } from '../../../services/contentful'
import mapSlugsToPaths from '../../../utils/map-slugs-to-paths'
import PageTemplate from '../../../templates/generic-page-template'
import HelpPostTemplate from '../../../templates/help-post-template'
import PageV2Template from '../../../templates/generic-page-template.v2'
import doStaticGeneration from '../../../utils/do-static-generation'

const templates = {
  topicPage: PageTemplate,
  helpPost: HelpPostTemplate,
  page_v2: PageV2Template,
}

const Page = ({ page }) => {
  const Template = templates[page.contentType]
  if (!Template) return null
  return <Template page={page} />
}

export async function getStaticProps({ preview, params }) {
  const client = preview ? previewClient : contentDeliveryClient
  const { parent } = params
  const siteConfig = await getSiteConfig({ client })
  const translations = await getTranslations({ client })
  const page =
    (await getHelpPost({ client, slug: parent, canonical: true })) ||
    (await getPage({ client, slug: parent, pageTypes: ['topic'] })) ||
    (await getTopicPage({ client, slug: parent }))

  return {
    props: {
      key: page?.id,
      page,
      preview: !!preview,
      siteConfig,
      translations,
    },
    revalidate: parseInt(process.env.REVALIDATE_WINDOW, 10),
    notFound: !page,
  }
}

export async function getStaticPaths() {
  let paths = []

  if (doStaticGeneration()) {
    const client = contentDeliveryClient
    const topicPageSlugs = await getTopicPageSlugs({ client, hasParent: false })
    const topicPageV2Slugs = await getPageSlugs({ client, hasParent: false, pageTypes: ['topic'] })
    const helpPostSlugs = await getHelpPostSlugs({ client, canonical: true })

    const slugs = [...topicPageSlugs, ...topicPageV2Slugs, ...helpPostSlugs]

    paths = mapSlugsToPaths({ slugs })
  }

  return {
    paths,
    fallback: 'blocking',
  }
}

export default Page
